// extracted by mini-css-extract-plugin
export default {"list":"payments-list_list__2VMQz","item":"payments-list_item__05YhG","paymentmeanwarning":"payments-list_paymentmeanwarning__3n9FS"};